export const COURSE = '/course'
export const COURSE_CREATE = `${COURSE}/create`
